import { IconDefinition } from "./types";

const penToSquare: IconDefinition = {
  iconName: "pen-to-square",
  width: 576,
  height: 512,
  svgPathData:
    "M221.6 278.3L362 137.9c14.7 14.7 29.4 29.4 44.1 44.1l-140.4 140.4-50.4 6.3 6.3-50.4zM418 126L395.9 104 440 59.9 484.1 104 440 148.1 418 126zm134-22C502.8 54.8 450.2 2.2 440-8L406.1 25.9 176 256c-7.2 57.5-12.5 100.2-16 128 27.8-3.5 70.5-8.8 128-16L518.1 137.9 552 104zM56 64l-24 0 0 448 448 0 0-224-48 0 0 176-352 0 0-352 176 0 0-48-200 0z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "pen-to-square",
  unicode: 0xf044,
};

export { penToSquare };
